"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const complex_utils_1 = require("complex-utils");
const currentDate = new Date();
const key = String(currentDate.getFullYear()) + String(currentDate.getMonth() + 1).padStart(2, '0') + String(currentDate.getDate()).padStart(2, '0');
const develop = {
    data: (0, complex_utils_1.getLocalData)('develop') === key,
    getData() {
        // 是否是开发环境或者线上环境的开发模式
        return (0, complex_utils_1.getEnv)('real') === 'development' || this.data;
    }
};
exports.default = develop;
